import { createSlice } from '@reduxjs/toolkit'

export const drawerRight = createSlice({
  name: 'drawerRight',
  initialState: { value: false, index: null },
  reducers: {
    show: (state, action) => {
      state.value = action.payload
    },
    codeTree: (state, action) => {
      state.index = action.payload
    },
  },
})

export const { show, codeTree } = drawerRight.actions
export default drawerRight.reducer
